/**
 * "Paquete de 100 unidades" (VTA-01). Sale donde se ve un precio —tarjeta,
 * carro, checkout— porque sin él $13.161 por un clavo parece un error.
 * Con la venta suelta no dibuja nada. La ficha dice más: `DetallePaquete`.
 */
import type { UnidadMedida } from '@elcarpintero/compartido';

import { textoPaquete } from '../../utilidades/paquete';
import { Icono } from './Icono';

export interface EtiquetaPaqueteProps {
  producto: { unidadesPorPaquete: number; unidadMedida: UnidadMedida };
}

export function EtiquetaPaquete({ producto }: EtiquetaPaqueteProps) {
  const texto = textoPaquete(producto);
  if (texto === null) return null;

  return (
    <p className="paquete">
      <Icono nombre="caja" />
      {texto}
    </p>
  );
}
